export default "__VITE_ASSET__AJG679jN__"